module.exports = __webpack_public_path__ + "img/index4.a78f3172.webp";